/* unplugin-vue-components disabled */var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('gmap-map',{ref:"map",staticClass:"map",attrs:{"options":{
        zoomControl: !0,
        mapTypeControl: !1,
        scaleControl: !1,
        streetViewControl: !1,
        rotateControl: !1,
        fullscreenControl: !0,
        disableDefaultUi: !1,
        scrollwheel: !1
      },"center":{ lat: _vm.site.lat, lng: _vm.site.lng },"zoom":15}},[_c('gmap-marker',{key:0,attrs:{"position":{ lat: _vm.site.lat, lng: _vm.site.lng }}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('gmap-street-view-panorama',{staticClass:"pano",attrs:{"options":{ scrollwheel: !1 },"position":{ lat: _vm.site.street.lat, lng: _vm.site.street.lng },"pov":{
        heading: _vm.site.street.heading,
        pitch: _vm.site.street.pitch,
        zoom: _vm.site.street.zoom
      },"zoom":1}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }